export default __webpack_public_path__ + "static/media/0K3A7290.5a1942cd.png";